import { Routes } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ProductGridComponent } from './product-grid/product-grid.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { LivefeedComponent } from './livefeed/livefeed.component';
import { SearchHelpComponent } from './search-help/search-help.component';
import { domainGuard } from './guards/domain.guard';

export const routes: Routes = [
  { path: 'privacypolicy', component: PrivacyPolicyComponent },
  { path: 'deals', component: ProductGridComponent, canActivate: [domainGuard] },
  { path: 'livefeed', component: LivefeedComponent, canActivate: [domainGuard] },
  { path: 'search-help', component: SearchHelpComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
  { path: '', redirectTo: '/deals', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent },
];
